import apiAxios from '../../services/apiAxios';
// import { getAccesos } from '../../helpers/user_nav';
import helpers from '../../mixins/helpers';

const state = {
  userId: 0,
  email: '',
  avatar: '',
  nombre: '',
  admin: false,

  // clienteId: '',
  // cliente: '',
  
  tokenString: '',

  authValid: false,
  passwordVencido: false
};

const mutations = {
  'LOGIN'(state, params) {
    state.userId = params.user.id;
    state.email = params.user.email;
    state.apellido = params.user.apellido;
    state.nombre = params.user.nombre;
    state.avatar = params.user.avatar;
    state.admin = params.user.admin;
    
    state.tokenString = params.tokenString;

    // if (params.cliente) {
    //   state.clienteId = params.cliente.id? params.cliente.id : 0;
    //   state.cliente = params.cliente.nombre? params.cliente.nombre.trim() : '';
    // } else {
    //   state.clienteId = 0;
    //   state.cliente = '';
    // }
  },
  // 'SET_CLIENTE'(state, params) {
  //   state.tokenString = params.tokenString;

  //   state.clienteId = params.cliente.id;
  //   state.cliente = params.cliente.nombre.trim();
  // },
  'LOGOUT'(state) {
    state.userId = 0;
    state.email = '';
    state.apellido = '';
    state.nombre = '';
    state.avatar = '';
    state.admin = false;

    state.tokenString = '';

    // state.clienteId = 0;
    // state.cliente = '';
  },
  'PERFIL'(params) {
    state.apellido = params.apellido;
    state.nombre = params.nombre;
    state.avatar = params.avatar;
  },
  'INICIALIZAR_AUTH'(state) {
    state.authValid = false;
    state.passwordVencido = false;
    },
  'SET_AUTH'(state, auth) {
    state.authValid = true;
    state.passwordVencido = auth.passwordVencido;
  },
};

const actions = {
  login: ( { commit  }, params) => {
    return new Promise((resolve, reject) => {
      commit('LOGOUT');

      apiAxios.post('auth/login', params) 
        .then(res => {
          commit('LOGIN', res.data);

          const now = new Date();
          const expirationDate = new Date(now.getTime() + 28800000);
          localStorage.setItem('email', res.data.user.email);
          localStorage.setItem('token', res.data.tokenString);
          localStorage.setItem('expirationDate', expirationDate);

          resolve();
        })
        .catch(error => reject(helpers.methods.getErrorMessage(error)));
    })
  },
  tryLogin ( { commit } ) {
    return new Promise((resolve, reject) => {
      /* Recuperamos los datos del localStorage */  
      var email = localStorage.getItem('email');
      var tokenString = localStorage.getItem('token');
      var expirationDate = new Date(localStorage.getItem('expirationDate', expirationDate));
      var currentDate = new Date();

      /* Validamos datos del usuario y la fecha de expiración */
      if (email && tokenString
          && expirationDate.getTime() > currentDate.getTime()) {
        
        var credenciales = {
          email: email,
          tokenString: tokenString
        }
        apiAxios.post('auth/autologin', credenciales) 
          .then(res => {
            commit('LOGIN', res.data);

            const now = new Date();
            const expirationDate = new Date(now.getTime() + 28800000);
            localStorage.setItem('email', res.data.user.email);
            localStorage.setItem('token', res.data.tokenString);
            localStorage.setItem('expirationDate', expirationDate);

            resolve();
          })
          .catch(error => reject(helpers.methods.getErrorMessage(error)));
        } else {
          reject();
        }
    })
  },
  logout: ({commit}) => {
      commit('LOGOUT');

      localStorage.removeItem('email');
      localStorage.removeItem('token');
      localStorage.removeItem('expirationDate');
  },
  // seleccionarCliente ( { commit  }, clienteId) {
  //   return new Promise((resolve, reject) => {
  //     apiAxios.post('auth/cliente/' + clienteId,) 
  //       .then(res => {
  //         commit('SET_CLIENTE', res.data);

  //         /* Actualizamos los datos del token */
  //         const now = new Date();
  //         const expirationDate = new Date(now.getTime() + 28800000);
  //         // localStorage.setItem('email', res.data.user.email);
  //         localStorage.setItem('token', res.data.tokenString);
  //         localStorage.setItem('expirationDate', expirationDate);

  //         resolve();
  //       })
  //       .catch(error => reject(helpers.methods.getErrorMessage(error)));
  //   })
  // },
  registrar ( {}, params ) {
    return new Promise((resolve, reject) => { 
      apiAxios.post('auth/register', params)
        .then(() => resolve())
        .catch(error => reject(helpers.methods.getErrorMessage(error)));
    })
  },
  forgotPassword ( {}, params ) {
    return new Promise((resolve, reject) => { 
      apiAxios.post('auth/forgot', params)
        .then(() => resolve())
        .catch(error => reject(helpers.methods.getErrorMessage(error)));
    })
  },
  resetPassword ( {}, params ) {
    return new Promise((resolve, reject) => { 
      apiAxios.post('auth/reset-password', params)
        .then(() => resolve())
        .catch(error => reject(helpers.methods.getErrorMessage(error)));
    })
  },
};

const getters = {
  loggedIn(state) {
    if (state.email) {
      if (state.email != '') {
        var expirationDate = new Date(localStorage.getItem('expirationDate', expirationDate));
        var currentDate = new Date();
  
        /* Validamos datos del usuario y la fecha de expiración */
        if (expirationDate.getTime() > currentDate.getTime()) {
          return true;
        }
      }
    }
    return false;
  },
  userId (state) {
    return state.userId;
  },
  email (state) {
    return state.email;
  },
  apellido (state) {
    return state.apellido;
  },
  nombre (state) {
    return state.nombre;
  },
  avatar (state) {
    return state.avatar;
  },
  admin (state) {
    return state.admin;
  },
  tokenString (state) {
    return state.tokenString;
  },
  // clienteSeleccionado(state) {
  //   if (state.clienteId) {
  //     if (state.clienteId != 0) {
  //       return true;
  //     }
  //   }
  //   return false;
  // },
  // clienteId (state) {
  //   return state.clienteId;
  // },
  // cliente (state) {
  //   return state.cliente;
  // },
  passwordVencido(state) {
    return (/true/i).test(state.passwordVencido);
  },

  tieneAcceso: (state) => (route) => {
    let accesoHabilitado = Boolean(false);

    let routePath = route.path;

    return true;

    // if (state.rolId == 1 || state.rolId == 2 || state.rolId == 6) {
    //   accesoHabilitado = Boolean(true);
    // } else {
    //   if (route.params) {
    //     if (route.params.hasOwnProperty('id')) {
    //       routePath = routePath.replace('/' + route.params.id, '/:id');
    //     }
    //     if (route.params.hasOwnProperty('clienteId')) {
    //       routePath = routePath.replace('/' + route.params.clienteId, '/:clienteId');
    //     }
    //   }

    //   //console.log(routePath);

    //   let accesos = getAccesos();
    //   //console.log(accesos);

    //   accesoHabilitado = accesos.find((acceso) => {
    //     return '/' + acceso.trim() == routePath
    //     || '/' + acceso.trim() + '/' == routePath
    //   });

    //   if (!accesoHabilitado) {
    //     //if (state.userId == 1) {
    //       console.log(routePath);
    //     //}
    //   }
    // }

    // return accesoHabilitado;
  },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}